import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import "./VisitCancelModal.css";
import CustomButton from "../Buttons/CustomButton";

const InfoModal = ({
  open: isOpen,
  handleClose,
  title,
  subtext,
  type,
  errors,
  secondaryTitle,
  primaryTitle,
  secondaryClick,
  primaryClick,
  buttonCustomWidth = "",
}) => {
  const [open, setOpen] = useState(isOpen);

  const isSuccess = type === "success";
  const isError = type === "error";

  const onClose = () => {
    setOpen(false);
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"sm"}
      fullWidth
    >
      <Grid
        className={`${
          isSuccess
            ? "success-header"
            : isError
            ? "error-header"
            : "info-header"
        }`}
      >
        <Grid className="d-flex justify-content-between align-items-center mx-3 my-2">
          <Grid className="d-flex align-items-center">
            <Typography className="cancel-title px-2 text-white">
              {isSuccess ? "Success" : isError ? "Error" : title}
            </Typography>
          </Grid>
          <IconButton onClick={handleClose}>
            <CloseIcon style={{ color: "#fff" }} />
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="info-subtext"
        >
          {errors != null ? (
            <>
              <p className="px-3 py-1 m-0 text-sm font-medium text-center text-red-400">
                <span className="m-0 font-bold">Few failed to move</span>:{" "}
              </p>
              <ul className="text-red-400 font-medium p-0 px-3">
                {errors.map((error, index) => (
                  <li key={index}>
                    {index + 1}. {error.error}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            subtext
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className={`flex gap-2 p-2 ${buttonCustomWidth}`}>
          {secondaryTitle && (
            <CustomButton
              className={`button-cancel ${"secondary-header"} w-full`}
              onClick={() => {
                setOpen(false);
                secondaryClick();
              }}
            >
              {secondaryTitle}
            </CustomButton>
          )}
          <CustomButton
            className={`button-cancel w-full ${
              isSuccess
                ? "success-header"
                : isError
                ? "error-header"
                : "info-header"
            }`}
            onClick={primaryClick ? primaryClick : onClose}
          >
            {primaryTitle ?? "Okay"}
          </CustomButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
